import { Box, BoxProps } from '@mui/material'
import { ReactNode } from 'react'
import useBreakpoint from '~hooks/use-breakpoint'

interface PageWrapperProps extends BoxProps {
  children: ReactNode
}

export function PageWrapper({ children, ...props }: PageWrapperProps) {
  const { isMobileSize } = useBreakpoint()
  const sxProp = props.sx
  const sxArray: any[] = Array.isArray(sxProp) ? sxProp : sxProp ? [sxProp] : []

  return (
    <Box
      {...props}
      sx={[
        {
          pt: isMobileSize ? 3 : 4,
          pb: isMobileSize ? 2 : 4,
          px: isMobileSize ? 2 : { xs: 4, xxxl: 14 },
        },
        ...sxArray,
      ]}
    >
      {children}
    </Box>
  )
}
